import {type List} from 'immutable';

import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type resultsQueryToString} from '../../helpers';
import {type ListFromAPI} from '../../lists-overview/types';
import type * as Models from './models';
import type * as Types from './types';

const domain = 'LISTS_FILTERS_AND_COLUMNS';

export const {
    action: fetchDescription,
    success: fetchDescriptionSuccess,
    failed: fetchDescriptionFailed,
} = createAction(
    `${domain}_FETCH_DESCRIPTION`,
    (institutionId: string, filtersAndColumnsKind: Types.FiltersAndColumnsKind) => ({
        institutionId,
        filtersAndColumnsKind,
    }),
    (filtersAndColumns: typeof Models.FiltersAndColumns.default) => ({filtersAndColumns}),
);

export const {action: changeFiltersAndColumnsKind} = createAction(
    `${domain}_CHANGE_filtersAndColumns_KIND`,
    (payload: {institutionId: string; filtersAndColumnsKind: Types.FiltersAndColumnsKind}) => payload,
);

export const {action: changeSettingsKind} = createAction(
    `${domain}_CHANGE_SETTINGS_KIND`,
    (settingsKind: Types.SettingsKind) => ({
        settingsKind,
    }),
);

export const {action: updateShownFilters} = createAction(`${domain}/UPDATE_FILTERS`, (shownFilters: string[]) => ({
    shownFilters,
}));

export const {action: hideFilterSection} = createAction(
    `${domain}/HIDE_FILTER_SECTION`,
    (filterEntityIds: List<string>) => ({
        filterEntityIds,
    }),
);

export const {
    action: createList,
    success: createListSuccess,
    failed: createListFailed,
} = createAction(
    `${domain}_CREATE_LIST`,
    (
        institutionId: string,
        name: string,
        filter: ReturnType<typeof resultsQueryToString>,
        kind: Types.FiltersAndColumnsKind,
    ) => ({
        institutionId,
        name,
        filter,
        kind,
    }),
    (response: ListFromAPI) => response,
);

export const {
    action: updateList,
    success: updateListSuccess,
    failed: updateListFailed,
} = createAction(
    `${domain}_UPDATE_LIST`,
    (presetId: string, name: string, filter: ReturnType<typeof resultsQueryToString>) => ({
        name,
        filter,
        presetId,
    }),
    (response: ListFromAPI) => response,
);

export const {action: reset} = createAction(`${domain}_RESET`, () => ({}));
